import { render, staticRenderFns } from "./ObservacionColegiada.vue?vue&type=template&id=15f3fdd6&"
import script from "./ObservacionColegiada.vue?vue&type=script&lang=js&"
export * from "./ObservacionColegiada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports